import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Footer } from './components/Footer';
import { LoginDialog } from './components/LoginDialog';
import { Toaster } from './components/Toaster';
import { getFromLS, saveToLS } from './lib/localStorageHelpers';
import { theme, themeLight } from './styles';
import { Navigation } from './components/Navigation';
import { smScreen } from './lib/constants';
import clsx from 'clsx';
import { useMediaQuery } from './hooks/useMediaQuery';
import { useAppView } from './contexts/AppViewContext';
import { useOperator } from './contexts/OperatorContext';

export const App = () => {
  const darkTheme = getFromLS('dark-theme');
  const darkModePreference = window.matchMedia(
    '(prefers-color-scheme: dark)'
  ).matches;
  const [isDarkMode, setIsDarkMode] = useState<boolean>(
    typeof darkTheme === 'object' ? darkModePreference : darkTheme
  );
  const isMobile = useMediaQuery(smScreen);
  const appView = useAppView();
  const operator = useOperator();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.pathname]);

  useEffect(() => {
    saveToLS('dark-theme', null, isDarkMode);
    if (isDarkMode) document.body.classList.add('dark');
    else document.body.classList.remove('dark');
  }, [isDarkMode]);

  return (
    <>
      <ThemeProvider theme={isDarkMode ? theme : themeLight}>
        <CssBaseline />
        <Navigation isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
        <Toaster />
        <div
          id="main-scroller"
          className={clsx(
            'mt-[70px] md:mb-[52px] pt-[45px] text-neutral-600 dark:text-white'
          )}
        >
          <div className={clsx('px-[25px]')}>
            {(appView.type === 'Operator' && operator.id !== 0) ||
            appView.type !== 'Operator' ? (
              <Outlet />
            ) : null}
          </div>
        </div>
        <Footer />
        <LoginDialog />
      </ThemeProvider>
    </>
  );
};
